export default "__VITE_ASSET__DLoPwPdN__"